import { trackEvent, eventNameConstants, interactionTypeConstants } from 'dibs-tracking';

const { EVENT_NAVIGATION } = eventNameConstants;
const { INTERACTION_TYPE_NOTIFICATIONS, INTERACTION_TYPE_GLOBAL_NAV } = interactionTypeConstants;

export const favoriteNotificationTrackingLabels: Record<string, string> = {
    EMPTY: 'empty state',
    ON_SALE: 'item price update',
    OFFER_MADE: 'item offer made',
    ITEM_SOLD: 'item sold',
    VIEW_ALL: 'view all',
    ITEM_NET_PRICE_DROP: 'price drop',
    ITEM_RETAIL_PRICE_DROP_GREATER_THAN_NET: 'price drop',
    ITEM_RETAIL_PRICE_DROP_NET_PRICE_NULL: 'price drop',
    ITEM_WEEKLY_SALE_PRICE_DROP: 'price drop',
};

export const notificationTrackingLabels: Record<string, string> = {
    AUTOMATED_OFFER: 'automated offer',
    PENDING_FEEDBACK: 'review purchase',
    TRADE_REWARD_PROGRAM: 'trade reward program',
    TRADE_REWARD: 'trade reward',
    VIEW_PROMO: 'view promo',
    VIEW_CONVERSATION: 'view conversation',
};

export const trackUserNotifications = ({
    stepInteractionName,
    trigger,
}: {
    stepInteractionName: string;
    trigger?: string;
}): void => {
    trackEvent({
        eventName: EVENT_NAVIGATION,
        interaction_type: INTERACTION_TYPE_NOTIFICATIONS,
        step_interaction_name: stepInteractionName,
        trigger,
    });
};

export const trackGlobalNavEvent = ({
    stepInteractionName,
    trigger,
}: {
    stepInteractionName: string;
    trigger?: string;
}): void => {
    trackEvent({
        eventName: EVENT_NAVIGATION,
        interaction_type: INTERACTION_TYPE_GLOBAL_NAV,
        step_interaction_name: stepInteractionName,
        trigger,
    });
};
